module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Cloud-upload-8b71fb8c29028060c43afbaeeb580d05.svg";